export const EVENT_TIME_RANGES = [
  { label: 'All events from past 90 days', value: '90d' },
  { label: 'Past 30 days', value: '30d' },
  { label: 'Past 7 days', value: '7d' },
  { label: 'Past 24 hours', value: '24h' },
  { label: 'Past 1 hour', value: '1h' },
] as const;

export type TimeRangeValue = (typeof EVENT_TIME_RANGES)[number]['value'];

const DURATION_MS: Record<TimeRangeValue, number> = {
  '90d': 90 * 24 * 60 * 60 * 1000,
  '30d': 30 * 24 * 60 * 60 * 1000,
  '7d': 7 * 24 * 60 * 60 * 1000,
  '24h': 24 * 60 * 60 * 1000,
  '1h': 60 * 60 * 1000,
};

/**
 * Returns a Unix timestamp (seconds) for the start of the given time range.
 * The Chargebee API expects timestamps in seconds, not milliseconds.
 */
export function getTimeRangeFrom(value: TimeRangeValue): number {
  return Math.floor((Date.now() - DURATION_MS[value]) / 1000);
}

export function getTimeRangeLabel(value: string): string {
  return (
    EVENT_TIME_RANGES.find((r) => r.value === value)?.label ?? 'All events'
  );
}
